import '@fortawesome/fontawesome-free/css/all.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import store from "../store"

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'fa',
  },
  theme: {
    dark: store.state.currentTheme == "dark"? true :false,
    themes:store.state.appThemes,
    options: { customProperties: true },
  },
});
